import { useState } from "react";
import { useParams } from "react-router-dom";
import { updatePassword } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const ChangePassword = () => {
    useBootstrapCSS();
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState({ text: "", type: "" });
    const [passwordError, setPasswordError] = useState("");

    const validatePasswordComplexity = (password) => {
        const minLength = 8;
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const nonAlphanumericRegex = /[-!"#$%&()*,./:;?@[\]^_`{|}~+<=]/;
        const repeatingCharsRegex = /(.)\1\1/;
        const forbiddenPatterns = /123|pass/i;

        if (password.length < minLength) {
            setMessage({ text: "Password must be at least 8 characters long.", type: "fail" });
            return false;
        }
        if (!uppercaseRegex.test(password)) {
            setMessage({ text: "Password must contain at least one uppercase letter.", type: "fail" });
            return false;
        }
        if (!lowercaseRegex.test(password)) {
            setMessage({ text: "Password must contain at least one lowercase letter.", type: "fail" });
            return false;
        }
        if (!nonAlphanumericRegex.test(password)) {
            setMessage({ text: "Password must contain at least one non-alphanumeric character.", type: "fail" });
            return false;
        }
        if (repeatingCharsRegex.test(password)) {
            setMessage({ text: "Password must not contain three repeating characters.", type: "fail" });
            return false;
        }
        if (forbiddenPatterns.test(password)) {
            setMessage({ text: "Password must not contain '123' or the word 'pass'.", type: "fail" });
            return false;
        }

        setPasswordError("");
        return true;
    };

    const validatePasswordMatch = () => {
        if (newPassword !== confirmPassword) {
            setMessage({ text: "Passwords do not match.", type: "fail" });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: "", type: "" });
        setPasswordError("");

        if (!validatePasswordComplexity(newPassword)) return;
        if (!validatePasswordMatch()) return;

        try {
            await updatePassword(token, newPassword);
            setMessage({ text: "Password updated successfully!", type: "success" });
            setTimeout(() => {
                window.location.href = "/login";
            }, 2000);
        } catch (error) {
            setPasswordError("Error updating password. Please try again.");
        }
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 form-outer h-100 px-5 align-items-center d-flex justify-content-center">
                        <form className="initial-form" onSubmit={handleSubmit}>
                            <h3 className="h3 mb-4">Change Password</h3>

                            <div className="form-group mb-30">
                                <label htmlFor="changePassword">New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="changePassword"
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </div>

                            <div className="form-group mb-30">
                                <label htmlFor="changeConfirmPassword">Confirm Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="changeConfirmPassword"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>

                            {passwordError && (
                                <div className="error_msg" style={{ backgroundColor: "#dc3545", color: "#fff", display: "block" }}>
                                    {passwordError}
                                </div>
                            )}

                            <div className="w-100 d-inine">
                                <button type="submit" className="btn btn-primary mb-30">
                                    Submit
                                </button>
                            </div>

                            {message.text && (
                                <div className={`message ${message.type === "success" ? "successmessage" : "failmessage"}`}>
                                    {message.text}
                                </div>
                            )}
                        </form>
                        <div className="form-footer">
                            <p>Copyright &copy; Compliance on Demand. All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ChangePassword;
